import _ from 'lodash';

import { AmazonLoginError } from '../errors/AmazonLoginError';
import AmazonAPIClient from '../lib/AmazonAPIClient';
import AuthToken from '../records/customer/AuthToken';

export const AMAZON_LOGIN_API_AUTHENTICATE = '/customers/auth/amazon';
export const AMAZON_LOGIN_ADDITONAL_HEADERS = { 'Accept-version': 'v2' };
export const AMAZON_AUTHENTICATED = true;

let options;

const AmazonLoginService = {
    async authenticate({ accessToken }) {
        let response;

        const request = {
            token: accessToken
        };

        try {
            response = await AmazonAPIClient.post(
                AMAZON_LOGIN_API_AUTHENTICATE,
                request,
                options,
                AMAZON_LOGIN_ADDITONAL_HEADERS
            );

            AmazonLoginService.retrieveProfile(accessToken);

            const token = AuthToken.fromAmazon(response);

            return { token, status: response.status };
        } catch (error) {
            if (error.body && error.body.status) {
                throw new AmazonLoginError(error.body.status, { customer: error.body.customer });
            }

            throw new AmazonLoginError(error);
        }
    },

    async init({ options: _options }) {
        const defaults = {
            handleOnRetrieveProfile: _.noop
        };
        options = { ...defaults, ..._options };
    },

    async linkAccount({ email = '', password = '' }) {
        const request = {
            email,
            password
        };

        return await AmazonAPIClient.put(AMAZON_LOGIN_API_AUTHENTICATE, request, options, AMAZON_LOGIN_ADDITONAL_HEADERS);
    },

    retrieveProfile(accessToken) {
        if (window.amazon && window.amazon.Login) {
            const callback = options && typeof options.handleOnRetrieveProfile === 'function' ? options.handleOnRetrieveProfile : _.noop;
            window.amazon.Login.retrieveProfile(accessToken, callback);
        }
    },

    async unlinkAccount() {
        return await AmazonAPIClient.delete(
            AMAZON_LOGIN_API_AUTHENTICATE,
            null,
            options,
            AMAZON_LOGIN_ADDITONAL_HEADERS,
            AMAZON_AUTHENTICATED
        );
    }
};

export default AmazonLoginService;



// WEBPACK FOOTER //
// ./src/services/AmazonLoginService.js